import dayjs from 'dayjs';

import type {NaiveDateTimeObj} from './types';

import {naiveDateTimeObjToISOString} from './naiveDateTimeObjToISOString';

export const naiveDateTimeObjToTimestamp = (
  dateObj: NaiveDateTimeObj | string,
) => {
  return dayjs(naiveDateTimeObjToISOString(dateObj)).valueOf();
};
